require(['jquery','../vendor/parsleyjs/dist/parsley.js'], function($, Parsley){

	$("#b2b-inquiry").on('submit', function (e) {
		e.preventDefault();
		$.post($(this).attr('action'),
			$(this).serialize(),
			function (data) {
				if (data.success) {
					//Track the Event
					ga('send', 'event', 'email', 'email', 'B2B Form');

					$("#b2b-inquiry").hide();
					$("#b2b-inquiry-success").show();
				} else {
					$("#b2b-inquiry").prepend('<h4 class="error text-center">' + data.message + '</h4>');
				}
			});
	});

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/src/scripts/b2b.js
 ** module id = 13
 ** module chunks = 9
 **/